module.exports = __webpack_public_path__ + "img/img-a8ecc04f.9887a6df.png";